import { db, storage } from "../firebase/config";
import { ref, uploadBytes, getDownloadURL, deleteObject } from "firebase/storage";
import { 
  collection, 
  doc, 
  addDoc, 
  updateDoc, 
  deleteDoc, 
  onSnapshot,
  arrayUnion,
  arrayRemove
} from "firebase/firestore";

export function subscribeToOpportunities(callback) {
  return onSnapshot(collection(db, "opportunities"), (snapshot) => {
    const list = [];
    snapshot.forEach((doc) => {
      list.push({ id: doc.id, ...doc.data() });
    });
    list.sort((a, b) => new Date(b.dateAdded) - new Date(a.dateAdded));
    callback(list);
  }, (error) => {
    console.error("Error subscribing to opportunities:", error);
    callback([], error);
  });
}

export async function addOpportunity(data) {
  const oppData = {
    ...data,
    dateAdded: data.dateAdded || new Date().toISOString(),
    notes: data.notes || [],
    attachments: data.attachments || []
  };
  const docRef = await addDoc(collection(db, "opportunities"), oppData);
  return docRef.id;
}

export async function updateOpportunity(id, data) {
  const docRef = doc(db, "opportunities", id);
  await updateDoc(docRef, data);
}

export async function deleteOpportunity(id) {
  const docRef = doc(db, "opportunities", id);
  await deleteDoc(docRef);
}

export async function addNoteToOpportunity(id, text, author) {
  const newNote = {
    id: Date.now().toString(),
    text,
    author,
    timestamp: new Date().toISOString()
  };
  
  const docRef = doc(db, "opportunities", id);
  await updateDoc(docRef, {
    notes: arrayUnion(newNote)
  });
  return newNote;
}

export async function deleteNoteFromOpportunity(id, note) {
  const docRef = doc(db, "opportunities", id);
  await updateDoc(docRef, {
    notes: arrayRemove(note)
  });
}

export async function uploadOpportunityAttachment(oppId, file) {
  const timestamp = Date.now();
  const filePath = `opportunities/${oppId}/${timestamp}_${file.name}`;
  const fileRef = ref(storage, filePath);
  
  await uploadBytes(fileRef, file);
  const downloadUrl = await getDownloadURL(fileRef);
  
  return {
    id: timestamp.toString(),
    name: file.name,
    url: downloadUrl,
    path: filePath
  };
}

export async function deleteOpportunityAttachment(filePath) {
  const fileRef = ref(storage, filePath);
  await deleteObject(fileRef);
}
